export default __webpack_public_path__ + "static/media/crypto-designer.14d8602a.gif";